<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<dash-gis-flexible-panel panelTitle="Line Isolation" (closePanel)="close()">
    <div class="isolation-list-container">
        <div>
            <div>
                <h2 class="mat-h2">Selected Line</h2>
                <div>{{ selectedLine }}</div>
            </div>
            <div>
                <h2 class="mat-h2">Valves</h2>
                <div class="item-list">
                    <span *ngFor="let node of isolatedNodes">{{ node }}</span>
                </div>
            </div>
            <div>
                <h2 class="mat-h2">Lines Affected</h2>
                <div class="item-list">
                    <span *ngFor="let line of isolatedLines">{{ line }}</span>
                </div>
            </div>
        </div>
        <div>
            <button mat-button (click)="selectFeatures()" color="primary">Select Highlighted</button>
        </div>
    </div>
</dash-gis-flexible-panel>
